// External
import React from 'react';
import PropTypes from 'prop-types';

// ott-common
import Rating from '@dtvgo/rating';
import '@dtvgo/rating/dist/main.css';

// Styles
import './AgeRating.scss';

// Utils
import { IS_BRAZIL, USE_PLAYER_UI_V2 } from '../../utils';

/**
 * Returns an age rating tag
 */
function AgeRating({ rating = '' }) {
  if (!rating) {
    return null;
  }

  const ratingClassName = !USE_PLAYER_UI_V2 ? 'dtv-web-age-rating' : 'dtv-web-age-rating-v2';

  return (
    <Rating
      rating={rating}
      brazil={IS_BRAZIL}
      className={ratingClassName}
    />
  );
}

AgeRating.propTypes = {
  rating: PropTypes.string,
};

AgeRating.defaultProps = {
  rating: '',
};

export default AgeRating;
